module.exports = __webpack_public_path__ + "img/nav_submit.9d835a16.jpg";